// extracted by mini-css-extract-plugin
module.exports = {"homepageBogoOfferModal":"BogoPromoModal_homepageBogoOfferModal__Bc8B8","badge":"BogoPromoModal_badge__Iyk_G"};